<template>
    <div class="table">
        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;">
                <el-select v-model="form.deptId" placeholder="请选择学校" @change="getModuleBindIndicators">
                    <el-option
                        v-for="item in depts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.serialNo" placeholder="编号"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-select v-model="form.moduleId" placeholder="评价模块" clearable >
                    <el-option
                        v-for="item in evaluateModules"
                        :key="item.moduleId"
                        :label="item.moduleTitle"
                        :value="item.moduleId">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.evaluateTitle" placeholder="评价指标"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.evaluateContent" placeholder="文字评价"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.name" placeholder="姓名"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.gradeName" placeholder="年级名称"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.className" placeholder="班级名称"></el-input>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    placeholder="评价开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker> 
                    
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    placeholder="评价结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker> 
            </div>
            <div style="display: inline-block; height:40px;">
                <el-select v-model="form.sourceSign" clearable placeholder="数据来源">
                    <el-option
                        v-for="item in sourceSigns"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.createName" placeholder="评价人"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-select v-model="form.fileType" clearable placeholder="请选择文件类型" style="width: 150px;">
                    <el-option
                        v-for="item in fileTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index"  label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="编号"  :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.serialNo !=null && scope.row.serialNo !='' ">
                            {{scope.row.serialNo}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="evaluateModule"  label="评价模块" width="130">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateModule == 1">
                            学生评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 2">
                            课堂评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 3">
                            班级评价/
                            <span v-if="scope.row.commonName != null">
                                {{scope.row.commonName}}/
                            </span>
                            {{scope.row.classEvaluateIndicatorsName}}
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 4">
                            实践评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 5">
                            教职评价
                            <span v-if="scope.row.commonName != null">
                                /{{scope.row.commonName}}
                            </span>
                            <span v-if="scope.row.classEvaluateIndicatorsName != null">
                                /{{scope.row.classEvaluateIndicatorsName}}
                            </span>
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 6">
                            成果评价
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价对象" width="80">
                    <template slot-scope="scope">
                        <!--评价目标（1-班级，2,3-姓名）-->
                        <div v-if="scope.row.evaluateTarget == 1">
                            班级
                        </div>
                        <div v-else>
                            {{scope.row.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价类型"  :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 1">
                            表扬
                        </div>
                        <div v-else-if="scope.row.evaluateType == 2">
                            待改进
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价指标"  :show-overflow-tooltip="true" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 3">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.evaluateTitle}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="文字评价"  :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 3">
                            {{scope.row.title}}
                        </div>
                        <div v-else>
                            {{scope.row.evaluateContent}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价分值"  width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 1">
                            +{{scope.row.evaluateScore}}
                        </div>
                        <div v-else-if="scope.row.evaluateType == 2">
                            <span style="color: red;">{{scope.row.evaluateScore}}</span>
                        </div>
                        <div v-else>
                            {{scope.row.evaluateScore}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="100"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.className">{{scope.row.className}}</div>
                        <div v-else>无</div>
                    </template>
                </el-table-column> 
                <el-table-column prop="sourceSign" label="数据来源"   width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sourceSign == 1">
                            课堂助手
                        </div>
                        <div v-else-if="scope.row.sourceSign == 2">
                            巡查助手
                        </div>
                        <div v-else-if="scope.row.sourceSign == 3">
                            小程序
                        </div>
                        <div v-else-if="scope.row.sourceSign == 4">
                            系统自动生成
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="eventTime" label="事件时间"   width="100"></el-table-column>
                <el-table-column prop="evaluateTime" label="评价时间"   width="100"></el-table-column>
                <el-table-column prop="createName" label="评价人"  width="80"></el-table-column>
                <el-table-column prop="" label="是否清零"  width="70">
                    <template slot-scope="scope">
                        <div v-if="scope.row.deleteSign == null 
                            || scope.row.deleteSign == '' ">
                            未清零
                        </div>
                        <div v-else style="color:red;">
                            已清零
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="60px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <div v-if="scope.row.commonSign > 0">
                            <el-button
                                @click.native.prevent="showData(scope.row)"
                                type="text"
                                size="small" style="color: #387EE8;">
                                查看附件
                            </el-button>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 查看附件弹出框 -->
        <div v-if="evaluateFileVisible">
            <evaluateFile ref="evaluateFile"></evaluateFile>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';
    import evaluateFile from '../evaluate/EvaluateFile.vue';

    export default {
        name:"",
        data(){
            return{
                evaluateFileVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:"",
                    serialNo:"",
                    moduleId:"",
                    evaluateTitle:"",
                    evaluateContent:"",
                    name:"",
                    className:"",
                    gradeName:"",
                    startDate:"",
                    endDate:"",
                    createName:"",
                    sourceSign:"",
                    fileType: ""
                },
                evaluateModules:[],
                depts:[],
                data:[],
                loading:false,
                loadingText:"",
                sourceSigns:[{
                    value: 1,
                    label: '课堂助手'
                }, {
                    value: 2,
                    label: '巡查助手'
                }, {
                    value: 3,
                    label: '小程序'
                }],
                fileTypes:[{
                    value: 1,
                    label: '图片'
                },{
                    value: 2,
                    label: '录音'
                },{
                    value: 3,
                    label: '视频'
                },]
            }
        },
        components: {
            evaluateFile
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                           this.getModuleBindIndicators();
                       }
                       this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.evaluateDetailArchiveListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    serialNo:this.form.serialNo,
                    tempModuleId:(this.form.moduleId=='0'?"":this.form.moduleId),
                    evaluateTitle:this.form.evaluateTitle,
                    evaluateContent:this.form.evaluateContent,
                    name:this.form.name,
                    gradeName:this.form.gradeName,
                    className:this.form.className,
                    startDate:this.form.startDate==null?"":this.form.startDate,
                    endDate:this.form.endDate==null?"":this.form.endDate,
                    createName:this.form.createName,
                    sourceSign:this.form.sourceSign,
                    fileType:this.form.fileType,
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           getModuleBindIndicators(){
                let url  = this.moduleBindIndicatorsListModuleUrl;
                let data = {
                    deptId:this.form.deptId,
                };
                
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data))
                    if(res.status==200){
                        this.evaluateModules = res.data;
                        this.form.moduleId="";
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
           },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            showData(row){
                this.evaluateFileVisible=true
                this.$nextTick(() => { 
                    this.$refs['evaluateFile'].init(this.form.deptId,row.id)
                })
            },
            exportExcel(){
                const maxCount = 65535
                if(this.common.total > maxCount){
                    let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                    this.$commonFn.showTip(msg,3)
                }else{
                    this.exportData()
                }
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待"
                let url=this.evaluateDetailArchiveListExcelUrl
                let param = new URLSearchParams()
                param.append('deptId', this.form.deptId)
                param.append('serialNo', this.form.serialNo)
                param.append('tempModuleId', (this.form.moduleId=='0'?"":this.form.moduleId))
                param.append('evaluateTitle', this.form.evaluateTitle)
                param.append('evaluateContent', this.form.evaluateContent)
                param.append('name', this.form.name)
                param.append('gradeName', this.form.gradeName)
                param.append('className', this.form.className)
                param.append('startDate', this.form.startDate==null?"":this.form.startDate)
                param.append('endDate', this.form.endDate==null?"":this.form.endDate)
                param.append('createName', this.form.createName)
                param.append('sourceSign', this.form.sourceSign)
                param.append('fileType', this.form.fileType)
                
                // 获取学校名称
                let schoolName=""
                for(let i=0;i<this.depts.length;i++){
                    if(this.form.deptId === this.depts[i].id){
                        schoolName = this.depts[i].name
                        break;
                    }
                }

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a")
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
                    link.style.display = "none"
                    link.href = URL.createObjectURL(blob)
                    link.setAttribute("download", schoolName+'-评价记录.xls')
                    document.body.appendChild(link)
                    link.click();
                    document.body.removeChild(link)
                    this.loading=false
                }).catch(error => {
                    console.log(error)
                    this.loading=false
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/Evaluate.vue